import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';

import app from './modules/app';
import eventeros from './modules/eventeros';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  actions,
  getters,
  modules: {
    app,
    eventeros,
  },
  state: {},
  mutations: {},
});

export default store;
